<template>
<div >
    <vx-card class="no-scroll-content" ref="content" title="List of Filed Loan" >

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewLoan()" icon-pack="feather" icon="icon-file">Apply Loan</vs-button>
        <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search  :data="employeeLoan">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <vs-th sort-key="loansCategoryId">Loan Category</vs-th>
                <vs-th sort-key="loansSubCategoryId">Sub Category</vs-th>
                <vs-th>Loan Amount</vs-th>
                <vs-th sort-key="periodId">Period</vs-th>
                <vs-th >Terms</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Reviewer</vs-th>
                <vs-th>Approver</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Reviewer Comment</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].loanCategoryId">
                        {{ loanCategoryName(data[indextr].loanCategoryId).loanCategoryName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanSubCategoryId">
                        {{ loanSubCategoryName(data[indextr].loanSubCategoryId).loanSubCategoryName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanAmount">
                        {{data[indextr].loanAmount }}
                    </vs-td>
                    <vs-td :data="data[indextr].periodId">
                        {{ periodName(data[indextr].periodId).periodName }}
                    </vs-td>
                    <vs-td :data="data[indextr].loanTerms">
                        {{data[indextr].loanTerms}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerId">
                        <vx-tooltip :text="data[indextr].reviewer.fullName">
                            <div v-if="data[indextr].reviewer.photoUrl !== ''"><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :src="data[indextr].reviewer.photoUrl" /></div>
                            <div v-else><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :text="data[indextr].reviewer.fullName" :color="data[indextr].reviewer.fullName.length < 12 ? 'success' : data[indextr].reviewer.fullName.length <= 15 ? 'primary' : data[indextr].reviewer.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                        </vx-tooltip>
                    </vs-td>
                    
                    <vs-td :data="data[indextr].approverId">
                        <vx-tooltip :text="data[indextr].approver.fullName">
                            <div v-if="data[indextr].approver.photoUrl !== ''"><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :src="data[indextr].approver.photoUrl" /></div>
                            <div v-else><vs-avatar  class="rounded-full shadow-md cursor-pointer block" size="30px" :text="data[indextr].approver.fullName" :color="data[indextr].approver.fullName.length < 12 ? 'success' : data[indextr].approver.fullName.length <= 15 ? 'primary' : data[indextr].approver.fullName.length <= 20 ? 'warning' : 'danger'" /></div>
                        </vx-tooltip>
                    </vs-td>
                    <vs-td  :data="data[indextr].photoId" >
                        <vs-icon v-show="data[indextr].photoId != '' && data[indextr].photoId != null" @click="downloadFile(data[indextr].photoId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                    </vs-td>
                    <!-- <vs-td  :data="data[indextr].photoUrl" >
                        <a v-if="data[indextr].photoUrl != null" :href="data[indextr].photoUrl" target="_blank"   ><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></a>
                    </vs-td> -->
                    <vs-td :data="data[indextr].isUnread">
                        <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                            data[indextr].isCancelled == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                            data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false
                                                              && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 
                            data[indextr].isApproverApproved == true ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                            data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                            data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' : ''"/>
                                {{data[indextr].isCancelled == true ? 'Cancelled' :
                                 data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Draft': 
                                 data[indextr].isSubmitted == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false  
                                                                   && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'For Review' :
                                data[indextr].isReviewerApproved == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false ? 'Reviewed - For Approval' :
                                 data[indextr].isApproverApproved == true ? 'Approved' :
                                 data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? 'For Revision' :
                                 data[indextr].isRetracted == true || data[indextr].isApproverRetracked == true ? 'Retracted' :
                                 data[indextr].isReviewerDenied == true || data[indextr].isApproverDenied == true ? 'Denied' : ''}}
                        </span>                                                             
                    </vs-td>
                    <vs-td :data="data[indextr].reviewerComment">
                        {{data[indextr].reviewerComment}}
                    </vs-td>
                    <vs-td>
                        <div class="vx-row">
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Edit' :
                                    data[indextr].isSubmitted == true && data[indextr].isApproverApproved == false && data[indextr].isApproverRevised == false && data[indextr].isApproverRetracked == false && data[indextr].isApproverDenied == false
                                                                      && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'Un-Submit' : 
                                    data[indextr].isReviewerApproved == true || data[indextr].isApproverApproved == true ? 'Retract' : 
                                    data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? ' Edit' : ''" >
                                    <!-- data[indextr].approversOTs[0].isRetracted == true ? 'Edit' : ''"> -->
                                    <vs-button class="mr-3 mb-2" @click="openEditLoan(data[indextr].employeeFiledLoansId)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="success" type="border" icon-pack="feather" icon="icon-edit-2" ></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="promptUnSubmitDialog(data[indextr].employeeFiledLoansId)" v-else-if="data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false" color="warning" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="promptRetrackDialog(data[indextr].employeeFiledLoansId)" v-else-if="data[indextr].isReviewerApproved == true" color="danger" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                    <vs-button class="mr-3 mb-2" @click="openEditLoan(data[indextr].employeeFiledLoansId)"  v-else-if="data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true" color="success" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                                    <!-- <vs-button class="mr-3 mb-2" v-else-if="data[indextr].approversOTs[0].isRetracted == true" color="success" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button> -->
                                    <!-- <vs-button v-else color="warning" type="border" icon-pack="feather" icon="icon-send" > </vs-button> -->
                                    
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Cancel' : 
                                data[indextr].isSubmitted == true  && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false ? 'Cancel' : 
                                data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true ? ' Cancel' : ''">
                                <!-- data[indextr].approversOTs[0].isRetracted == true ? 'Cancel' : ''"> -->
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledLoansId)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="danger" type="border" icon-pack="feather" icon="icon-x" ></vs-button>
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledLoansId)" v-else-if="data[indextr].isSubmitted == true && data[indextr].isReviewerApproved == false && data[indextr].isReviewerRevised == false && data[indextr].isRetracted == false && data[indextr].isReviewerDenied == false" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                <!-- <vs-button class="mb-2" v-else-if="data[indextr].approversOTs[0].isApproved == true" color="danger" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>-->
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledLoansId)" v-else-if="data[indextr].isReviewerRevised == true || data[indextr].isApproverRevised == true" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                <!-- <vs-button class="mb-2" v-else-if="data[indextr].approversOTs[0].isRetracted == true" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button> -->
                                     
                                </vx-tooltip>
                            </div>
                            <!--  -->
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>

    </vx-card>


    
        <!-- ADD Loan -->
        <vs-prompt
            class="email-compose"
            title="Apply Loan"
            accept-text= "Submit"
            @accept="onAddLoan"
            :is-valid="validForm"
            :active.sync="activePromptAddLoan">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getLoanTypes"> -->
            
            
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Category</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="loanCategory" label="loanCategoryName" :options="getAllLoanCategory"/>
                 
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Loan SubCategory</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="loanSubCategory" label="loanSubCategoryName" :options="getAllLoanSubCategory"/>
                 
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Loan Amount</span><span style="color:red">*</span>
                    <vs-input name="loanAmount" v-validate="'required'" class="w-full"  v-model="loanAmount"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Period</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="period" label="periodName" :options="getAllPeriodByPaymentMode"/>
                 </div>
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">No of Terms : </span>
                    <vs-input v-model="noOfTerms"/>
                
                </div>
            </div>
           
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reason</span><span style="color:red">*</span>
                    <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="reason"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
           <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reviewer</span><span style="color:red">*</span>
                    <!-- <v-select  class="w-full" v-model="loanReviewerName" label="fullName" ></v-select> -->
                    <vs-input name="reviewer" v-validate="'required'" class="w-full pointer-events-none" placeholder="Reviewer" v-model="loanReviewerName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Approver</span><span style="color:red">*</span>
                    <vs-input name="approver" v-validate="'required'" class="w-full pointer-events-none" placeholder="Approver" v-model="loanApproverName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2">
                   <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" text="Attachments"
                           />
                  
            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>




        <!-- EDIT Loan -->
         <vs-prompt
            class="email-compose"
            title="Edit Loan"
            accept-text= "Submit"
            @accept="onEditLoan"
            :is-valid="validForm"
            :active.sync="activePromptEditLoan">
            <vx-card title="Edit the following information">
            
            
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Category</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="loanCategory" label="loanCategoryName" :options="getAllLoanCategory"/>
                 
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">Loan SubCategory</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="loanSubCategory" label="loanSubCategoryName" :options="getAllLoanSubCategory"/>
                 
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Loan Amount</span><span style="color:red">*</span>
                    <vs-input name="loanAmount" v-validate="'required'" class="w-full"  v-model="loanAmount"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
            
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Terms</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="period" label="periodName" :options="getAllPeriodByPaymentMode"/>
                 </div>
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">No of Terms : </span>
                    <vs-input v-model="noOfTerms"/>
                
                </div>
            </div>
           
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reason</span><span style="color:red">*</span>
                    <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="reason"></vs-input>
                    <!-- <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*"> -->
                </div>
            </div>
          <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reviewer</span><span style="color:red">*</span>
                    <!-- <v-select  class="w-full" v-model="loanReviewerName" label="fullName" ></v-select> -->
                    <vs-input name="reviewer" v-validate="'required'" class="w-full pointer-events-none" placeholder="Reviewer" v-model="loanReviewerName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-3">  
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Approver</span><span style="color:red">*</span>
                    <vs-input name="approver" v-validate="'required'" class="w-full pointer-events-none" placeholder="Approver" v-model="loanApproverName.fullName" ></vs-input>
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2">
                    <div  class="vx-col w-full mb-2">
                    <vs-button v-show="!isFileReplaced" @click="downloadFile(photoId)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachmentName}}</vs-button>
                </div>
                
                    <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar"  text="Attachments"/>
                  
            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>






        <!-- UNSUBMITDIALOG -->
        <vs-prompt
            title="Loan Un-Submit"
            @accept="onUnSubmit"
            accept-text= "Yes"
            :active.sync="activeUnSubmitDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            </div>
        </vs-prompt>


         <!-- RETRACK ADD COMMENT -->
        <vs-prompt
            title = "Loan Retract"
            @accept="onRetracked"
            accept-text= "Yes"
            :active.sync="activeRetrackDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="Comment" v-model="reviewerComment" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validreviewerComment" color="danger" vs-icon="new_releases" >
                This can not be empty please enter reviewerComment
            </vs-alert>
            </div>
        </vs-prompt>


         <!-- CANCEL Loan -->
        <vs-prompt
            title = "Loan Cancel"
            @accept="onCancelled"
            accept-text= "Yes"
            :active.sync="activeCancelDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="reviewerComment" v-model="reviewerComment" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validreviewerComment" color="danger" vs-icon="new_releases" >
                This can not be empty please enter reviewerComment
            </vs-alert>
            </div>
        </vs-prompt>

    </div>


    
</template>

<script>
import Datepicker   from 'vuejs-datepicker'
import { en, he }   from 'vuejs-datepicker/src/locale'

import moduleLoans from '@/store/loans/moduleLoans.js'

import moment       from 'moment'
import vSelect      from 'vue-select'

import flatPickr    from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
         return {
            selected            :[],
            employeeFiledLoansId: null,
            loanCategory        :[],
            loanSubCategory     :[],
            loanAmount          : 0.00,
            termsType           :[],
            period              :[],
            noOfTerms           : 1,
            reason              : '',
            isDraft             : false,
            isSubmitted         : true,
            submittedOn         : null,
            isCancelled         : false,
            cancelledOn         : null,
            photoId             : null,
            subscriptionId      : '58804fc5-45d5-46cb-a892-09fdda5824b4',
            comments            :'',
            reviewerComment     : '',
            approverComment     : '',
            uploadPhoto         : [],
            dataImg             : null,
            loanReviewerName    : [],
            loanApproverName    : [],

            // paymentMode         : 0,

            
            activePromptAddLoan : false,
            activePromptEditLoan: false,
            activeUnSubmitDialog: false,
            activeRetrackDialog : false,
            activeCancelDialog  : false,

            format              : "d MMMM yyyy",

            attachmentName: '',

            isFileReplaced: false,
         }   
    },
    created(){
        this.$store.registerModule('loans', moduleLoans)
        this.$store.dispatch('tenants/getAllSignatories', { tenantsId : this.$store.state.AppActiveUser.tenantsId })
                .then((res) => {
                    this.loanReviewerName = res.data.data.loanReviewer
                    this.loanApproverName = res.data.data.loanApprover
                })
        const payload = {
                    sortBy: 'CreatedOn',
                    sortOrder: 'Desc',
                    pageNumber: 1,
                    pageSize: -1,
                    isApprover: false
                }
                this.$store.dispatch('loans/getAllEmployeeLoans', payload)
        
        this.$store.dispatch('hrms/getAllSalaryInformation', this.$store.state.AppActiveUser.uid).catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllLoanCategory').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllLoanSubCategory').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllPeriodLookup').catch((err) => { console.log(err)})
        
        // this.loanReviewerName = this.getReviewer.fullName
        // this.loanApproverName = this.getApprover.fullName
        // this.paymentMode = paymentModeId
                    // this.$store.dispatch('loans/getAllLoanType')
    },
    beforeDestroy () {
        this.$store.unregisterModule('loans')
    },
    computed: {
        employeeLoan() {
            return this.$store.state.loans.employeeFiledLoans
        },
        getAllLoanCategory() {
            return this.$store.state.lookup.loanCategory
        },
        getAllLoanSubCategory() {
            return this.$store.getters['lookup/loanSubCategoryByCategory'](this.loanCategory.loanCategoryId)
        },
        getTermsType(){
            return this.$store.state.lookup.getAllTermsType
        },
        getAllPeriodByPaymentMode() {
            return this.$store.getters['lookup/periodLookupByPaymentMode'](this.getSalaryInformation.paymentModeId) 
        },
        getLoanReviewerApprover() {
             return   this.$store.dispatch('tenants/getAllSignatories', { tenantsId : this.$store.state.AppActiveUser.tenantsId })
                        .then(res => {
                            res.data.data
                        })
                        .catch(() => {
                            null
                        })
            
           // return this.$store.state.tenants.signatories.loanReviewer//this.$store.state.tenants.signatories.loanReviewer.firstName + ' ' + this.$store.state.tenants.signatories.loanReviewer.lastName
        },
        getReviewer() {
            return this.$store.state.tenants.signatories.loanReviewer
        },
        getApprover(){
            // return this.getLoanReviewerApprover.approver.fullName
            return this.$store.state.tenants.signatories.loanApprover//this.$store.state.tenants.signatories.loanApprover.firstName + ' ' + this.$store.state.tenants.signatories.loanApprover.lastName
        },
        getSalaryInformation(){
            return this.$store.state.hrms.employeeSalaryInformation
        },
        validForm() {
            return this.loanCategory != null && this.loanSubCategory != null  && this.termsType != null && this.noOfTerms != 0 &&
            this.loanAmount > 0
        },
        validreviewerComment(){
            return  (this.reviewerComment.length > 0)
        },
        loanCategoryName() {
            return (id) => this.$store.getters['lookup/loanCategoryLookup'](id) 
        },
        loanSubCategoryName() {
            return (id) => this.$store.getters['lookup/loanSubCategoryLookup'](id) 
        },
        termsTypeName(){            
            return (id) => this.$store.getters['lookup/termsTypeLookup'](id)
        },
        periodName() {
            return (id) => this.$store.getters['lookup/periodLookup'](id)
        },
        
        

    },
    watch: {
        // loanCategory(){
        //   this.loanSubCategory = this.getLoanSubCategory(this.loanCategory.loanCategoryId)
        // },
        
        isDraft() {
            if(!this.isDraft)
                this.isSubmitted = true
        },
    },
    methods: {
        
        promptAddNewLoan() {
            this.disabledFrom = false
            this.addNewLoanDialog()
        },
        addNewLoanDialog() {
            
            this.clearFields()
            this.fromTime = new Date()
            this.toTime = new Date()
            // this.approvers = this.$store.getters['loans/approverName']().approverId
            this.activePromptAddLoan = true
        },
        clearFields() {
            this.loanCategory = this.toTime = this.approvers = this.reason = ""
            this.photoId = null
            // this.labelLocal = "pending";
        },
        onAddLoan() {

            // Loading
            this.$vs.loading()

            if(this.isDraft) {
                this.isDraft = true
                this.isSubmitted = false
                this.submittedOn = null
            }else {
                this.submittedOn = new Date()
            }
            const data = {
                loanCategoryId: this.loanCategory.loanCategoryId,
                loanSubCategoryId: this.loanSubCategory.loanSubCategoryId,
                loanAmount: this.loanAmount,
                // termsTypeId: this.termsType.value,
                periodId: this.period.periodId,
                loanTerms: this.noOfTerms,
                reason: this.reason,
                isDraft: this.isDraft,
                isSubmitted: this.isSubmitted,
                submittedOn: this.submittedOn,
                isCancelled: this.isCancelled,
                cancelledOn: this.cancelledOn,
                reviewerId: this.loanReviewerName.userId,
                approverId: this.loanApproverName.userId,
                photoId: this.photoId != null ? this.photoId : null,
                subscriptionId: this.subscriptionId,
            }
            //console.log(data)
            this.$store.dispatch('loans/addLoans', data)
            .then((response) => {
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft)
                        this.$alert("You have successfully updated your loan request and saved as draft", 'Draft Save Successfully', "success")
                    else 
                        this.$alert("You have successfully submitted your loan request", 'Leave Submitted', "success")
                    
                }
                else
                    this.$alert("", response.statusText, "error")
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
            })

            
        },
        openEditLoan(Id){
                //console.log('OPENEDIT')
                //console.log(Id)
                const e = this.$store.getters['loans/employeeFiledLoans'](Id) 
                //console.log(e)
                this.employeeFiledLoansId = e.employeeFiledLoansId,
                this.loanCategory = this.loanCategoryName(e.loanCategoryId),
                this.loanSubCategory = this.loanSubCategoryName(e.loanSubCategoryId),
                this.loanAmount = e.loanAmount,
                // this.termsType = this.termsTypeName(e.termsTypeId),
                this.period = this.periodName(e.periodId),
                this.noOfTerms = e.loanTerms,
                this.reason= e.reason,
                this.isDraft= e.isDraft,
                this.isSubmitted= e.isSubmitted,
                this.submittedOn= e.submittedOn,
                this.isCancelled= e.isCancelled,
                this.cancelledOn= e.cancelledOn,
                this.photoId= e.photoId != null ? e.photoId : null,
                this.subscriptionId= e.subscriptionId
                // this.loanReviewerName = this.getReviewer.fullName
                // this.loanApproverName = this.getApprover.fullName
                this.activePromptEditLoan = true
                // this.$refs.upldphto.filesx[0] = "https://localhost:44346/api/photo/jpeg/20d4b681_bbfa_48bf_8bb4_cc79faa1529c.jpg"
            
        },
        onEditLoan() {
            
            const data = {
                employeeFiledLoansId: this.employeeFiledLoansId,     
                loanCategoryId: this.loanSubCategory.loanCategoryId,
                loanSubCategoryId: this.loanSubCategory.loanSubCategoryId,
                loanAmount: this.loanAmount,
                periodId: this.period.periodId,
                // termsTypeId: this.termsType.value,
                loanTerms: this.noOfTerms,
                reason: this.reason,
                isDraft: this.isDraft,
                isSubmitted: this.isSubmitted,
                submittedOn: this.submittedOn,
                isCancelled: this.isCancelled,
                cancelledOn: this.cancelledOn,
                photoId: this.photoId != null ? this.photoId : null,
                subscriptionId: this.subscriptionId,
                reviewerId: this.loanReviewerName.userId,
                approverId: this.loanApproverName.userId,
            }
            this.$vs.loading()
            this.$store.dispatch('loans/updateLoans', data)
           .then((response)=> {
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft){
                        this.$alert("You have successfully updated your loan request and saved as draft", 'Draft Save Successfully', "success")
                        }else {
                        this.$alert("You have successfully submitted your loan request", 'Loan Submitted', "success")
                    }
                }
                else
                    this.$alert("", response.statusText, "error")

            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
                })
        },
        onUnSubmit() {
                ////console.log(employeeFiledLoansId)
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId: this.employeeFiledLoansId,
                    action: "UNSUBMIT", 
                    isDraft : true, 
                    isSubmitted: false,
                    reviewerId: this.loanReviewerName.userId
                }
                this.$store.dispatch('loans/unSubmit', data)
               .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("You have successfully un-submit your loan request", 'Un-Submit Successfully', "success")
                    else
                            this.$alert("", response.statusText, "error")
               })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                })


        },
        onRetracked() {
                ////console.log(employeeFiledLoansId)
                this.$vs.loading()
                const data = {
                    employeeFiledLoansId: this.employeeFiledLoansId,
                    action: "RETRACKED", 
                    isDraft : false, 
                    isRetracted: true, 
                    RetrackedOn : this.currentDate, 
                    isReviewerApproved : false, 
                    isApproverApproved : false,
                    remarks : this.comments,
                    reviewerId: this.getReviewer.userId
                }
                this.$store.dispatch('loans/onRetracked', data)
                .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully retracted your loan request", 'Retracted Successfully', "success")
                        else 
                            this.$vs.loading.close()
                    })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        onCancelled() {
                this.$vs.loading()
                 const data = {
                    employeeFiledLoansId: this.employeeFiledLoansId,
                    action: "CANCELLED", 
                    isDraft : false, 
                    isSubmitted: false, 
                    isCancelled : true, 
                    cancelledOn : this.currentDate, 
                    isReviewerRevised : false, 
                    isApproverRevised: false,
                    remarks : this.comments,
                    reviewerId: this.getReviewer.userId
                }
                this.$store.dispatch('loans/onCancelled', data)
                .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully cancelled your loan request", 'Cancelled Successfully', "success")
                        else
                            this.$alert("", response.statusText, "error")
                    })
                .catch((error) => {
                        this.$vs.loading.close()
                        this.$alert( error.message, "Error", "error")
                    })


        },
        successUpload(){
            
            this.$vs.notify({color:'success',title:'Upload Success',text:''})
        },
        deleteUpload(){
            this.$store.dispatch('deleteFile', this.photoId)
                .then(() => {
                    this.photoId = null
                })
        },
        
        updateCurrImg (e) {
            
            if(this.$refs.upldphto.filesx[0].type =='application/x-msdownload')
            {
                this.$vs.notify({
                        title: 'Info',
                        text: "File not allowed",
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'warning'
                        })
                return
            }
                
            this.$vs.loading()
            if(this.$refs.upldphto.filesx.length > 0)
            {

                let files = this.$refs.upldphto.filesx

                files.forEach(file => {

                    if(!file.remove)
                    {
                        let formData = new FormData()
                    
                        formData.append('UserId',  this.$store.state.AppActiveUser.uid)
                        formData.append('Title', this.loanCategory.loanCategoryName)
                        formData.append('Description', this.reason)
                        formData.append('Path', "")
                        formData.append('BlobContainer', "")
                        formData.append('OrigFilename', file.name)
                        formData.append('ContentType', file.type)
                        formData.append('Tags', "")
                        formData.append('file', file)
                        
                        this.$store.dispatch('uploadFile', formData)
                            .then((response) => {
                                this.$vs.loading.close()
                                if(response.status == 200){
                                    this.photoId = response.data.item2
                                }
                                    
                            })
                            .catch((error) => {
                                this.$vs.loading.close()
                                console.log(error.message)
                            })
                    }
                });
            }




             this.$vs.loading.close()
        },
        downloadFile(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
        },
        getAttachmentName(fileId){
            this.$store.dispatch('downloadFile', fileId)
                .then((response) => {
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    this.attachmentName = fileName.replace('"', '').replace('"', '')
                })
        },
        promptUnSubmitDialog(Id) {
            this.reviewerComment = ''
            this.employeeFiledLoansId = Id
            this.activeUnSubmitDialog = true
        },
        promptRetrackDialog(Id) {
            this.reviewerComment = ''
            this.employeeFiledLoansId = Id
            this.activeRetrackDialog = true
        },
        promptCancelDialog(Id) {
            this.reviewerComment = ''
            this.employeeFiledLoansId = Id
            this.activeCancelDialog = true
        },
        refreshcard () {
            this.$vs.loading({
                container: this.$refs.content,
                scale: 0.5
            })
            this.tempHidden = true
            this.$emit('refresh', this)
        },
        
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
// @import "@/assets/scss/vuexy/apps/simple-calendar.scss";


</style>